import React from "react";

import { Props } from "./types";

function ToggleArrow({ className, style }: Props) {
  return (
    <svg
      className={className}
      style={style}
      id="icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8.411 13.914"
    >
      <path
        d="M6.417,5.124,11.268.269a.913.913,0,0,1,1.295,0,.925.925,0,0,1,0,1.3l-5.5,5.5A.915.915,0,0,1,5.8,7.1L.267,1.572A.917.917,0,0,1,1.562.273Z"
        transform="translate(0.5 13.414) rotate(-90)"
      />
    </svg>
  );
}

export { ToggleArrow };
